import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MagezineDetail, Profile, ProfileAllPost, ProfileSetting } from '../../shared/interfaces/index.interface';
import { GeneralService, JwtService } from '../index.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, filter, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService implements OnInit {
  readonly BASE_URL = environment.BASE_API_URL;
  readonly QUIZ_BASE_URL = environment.QUIZ_API_URL;


  constructor(
    private http: HttpClient,
    private jwtService: JwtService,
    private location: Location,
    private GeneralService: GeneralService, 
    private router: Router
  ) { }
  ngOnInit() { }
  getProfile(name: string) {
    return this.http.get<Profile>(`${this.BASE_URL}auth/users/${name}/`)
  }
  editProfile(data: Profile) {
    return this.http.patch<Profile>(`${this.BASE_URL}auth/users/me/`, data)
  }
  sendNewPost(data: any) {
    return this.http.post(`${this.BASE_URL}user_post/`, data)
  }
  getCurrentUserAllPost() {
    return this.http.get(`${this.BASE_URL}user_post/?ordering=-publish_date`)
  }
  getCurrentUserSinglePost(slug: any) {
    return this.http.get(`${this.BASE_URL}user_post/${slug}/`)
  }
  isUserPassedExam(quiz: string, username: string) {
    return this.http.get(`${this.QUIZ_BASE_URL}/multiple_criteria/result/?exam__username__in=${quiz}&user_username=${username}`)
  }
  deleteCurrentUserSinglePost(slug: any) {
    return this.http.delete(`${this.BASE_URL}user_post/${slug}/`)
  }
  getProfileAllPost(name: string, page: number = 1) {
    return this.http.get<ProfileAllPost>(`${this.BASE_URL}post/?author__username=${name}&page=${page}&ordering=-publish_date`);
  }
  getProfileSavedPost(page: number = 1) {
    return this.http.get<ProfileAllPost>(`${this.BASE_URL}post/my_bookmarked_posts/?page=${page}`);
  }
  getMagezineUserList(username: string, page: number = 1) {
    return this.http.get<MagezineDetail>(this.BASE_URL + `magazine/?user__username=${username}&page=${page}`)
  }
  profileSetting(username: string) {
    return this.http.get<any>(this.BASE_URL + `user_role/profile_setting/${username}`)
  }
  updateSetting(username: string, data: any) {
    return this.http.patch<any>(this.BASE_URL + `user_role/profile_setting/${username}/`, data)
  }
  getCItyById(id: number) {
    return this.http.get(this.BASE_URL + `place/city/?id=${id}`)
  }
  replaceUrlState(data: any) {
    let urlArray = this.router.url.split('/')
    if (urlArray[1] == 'hamafarin' && data.username == urlArray[2].split('-').slice(0, 2).join('-')) {
      urlArray[2] = `${data?.username}-${this.GeneralService.RegProfileUrl(data?.first_name)}-${this.GeneralService.RegProfileUrl(data?.last_name)}`
      this.location.replaceState(`${urlArray.join('/')}`)
    }
  }
}
